import { render, staticRenderFns } from "./Jfxhjl.vue?vue&type=template&id=bbbc566e&scoped=true"
import script from "./Jfxhjl.vue?vue&type=script&lang=js"
export * from "./Jfxhjl.vue?vue&type=script&lang=js"
import style0 from "./Jfxhjl.vue?vue&type=style&index=0&id=bbbc566e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc566e",
  null
  
)

export default component.exports